<template>
  <v-container>
    <detail-view
      :title="'Detalles del Pedido'"
      :icon="'mdi-dolly'"
      :items="pedidoItems"
      :loading="loading"
    >
      <template v-slot:actions>
        <v-btn icon @click="editPedido">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="deletePedido">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </detail-view>
  </v-container>
</template>

<script>
import DetailView from '@/components/DetailView.vue'
import { forEach } from 'lodash'

export default {
  components: {
    DetailView
  },
  data () {
    return {
      loading: true,
      pedido: null,
      pedidoItems: [],
      pedidoi: [
        {
          id: '1',
          pedido: '1',
          proveedor: 'Proveedor 1',
          fecha: '2021-01-01',
          marca: 'Marca 1',
          modelo: 'Modelo 1',
          estado: 'En proceso'
        },
        {
          id: '2',
          pedido: '2',
          proveedor: 'Proveedor 2',
          fecha: '2021-01-02',
          marca: 'Marca 2',
          modelo: 'Modelo 2',
          estado: 'Recibido'
        },
        {
          id: '3',
          pedido: '3',
          proveedor: 'Proveedor 3',
          fecha: '2021-01-03',
          marca: 'Marca 3',
          modelo: 'Modelo 3',
          estado: 'Recibido'
        }
      ]
    }
  },
  async created () {
    await this.loadPedidoDetails()
  },
  methods: {
    async loadPedidoDetails () {
      try {
        this.loading = true
        const pedidoId = this.$route.params.id

        forEach(this.pedidoi, (pedidon) => {
          if (pedidon.id === pedidoId) {
            this.pedido = pedidon
            this.pedidoItems = [
              { label: 'No Pedido', value: this.pedido.pedido },
              { label: 'Nombre', value: this.pedido.proveedor },
              { label: 'Dirección', value: this.pedido.fecha },
              { label: 'Estado', value: this.pedido.estado },
              { label: 'Marca', value: this.pedido.marca },
              { label: 'Modelo', value: this.pedido.modelo }
            ]
          }
        })
      } catch (error) {
        console.error('Error al cargar los detalles de la ubicación:', error)
      } finally {
        this.loading = false
      }
    },
    editUbicacion () {
      this.$router.push({ name: 'PedidoForm', params: { id: this.pedido.pedido } })
    },
    deleteUbicacion () {
      // Lógica para eliminar la ubicación
    }
  }
}
</script>

<style scoped>
</style>
